import React, { useState, useEffect } from 'react';
import styles from './AddShop.module.scss';
// import { useIntl, history, useModel } from 'umi';
import Layout from '../../../layouts/User';
import { Form, Button, Input, Row, Col, message } from 'antd';
import axios from 'axios';
import { BASE_URL } from '../../../config';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export type Props = {};

const breadcrumbs = [
  {
    text: 'หน้าแรก',
    path: '/',
  },
  {
    text: 'ร้านค้าของฉัน',
    path: '/my-shops',
  },
  {
    text: 'เพิ่มร้านค้า',
    path: '/user/sales/shipments',
  },
];

const AddShopCreate: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [allMyShop, setAllMyShop] = useState<any>([]);
  const [form] = Form.useForm();
  const [allShops, setAllShops] = useState<any>({});
  const [state, setState] = useState<any>({
    myshops: [],
  });

  const getMyShop = async (userId: any) => {
    const myShop = await axios.get(
      `${BASE_URL}/shop-buyer/shop-buyer/${userId}`
    );

    setAllMyShop(myShop);
  };

  const getAllShop = async () => {
    const shops = await axios.get(`${BASE_URL}/shops`);
    let allDataShop: any = shops.data.data;
    for (let j = 0; j < shops.data.data?.length; j++) {
      if (allMyShop.data) {
        for (let i = 0; i < allMyShop.data?.length; i++) {
          if (shops.data.data[j]._id === allMyShop.data[i].shop._id) {
            allDataShop[j] = { ...shops.data.data[j], isMyShop: true };
          }
        }
      }
    }
    form.setFieldsValue({ searchShop: '' });
    const activeShops = allDataShop.filter(
      (x: any) => x?.shopIsActived === true
    );
    setAllShops({ data: [] });
  };

  const onFinish = async (values: any) => {
    if (values?.searchShop) {
      const shops = await axios.get(
        `${BASE_URL}/shops/get-shop-code/${values?.searchShop}`
      );
      let allDataShop: any = shops?.data;
      for (let i = 0; i < allMyShop?.data?.length; i++) {
        if (shops?.data?._id === allMyShop?.data[i]?.shop?._id) {
          allDataShop = { ...shops?.data, isMyShop: true };
        }
      }
      // console.log("allDataShop?.length", allDataShop);

      if (allDataShop) {
        setAllShops({ data: [allDataShop] });
      } else {
        message.warning('ไม่พบ รหัสร้านค้า');
      }
    } else {
      message.warning('กรุณากรอก รหัสร้านค้า');
    }
  };

  const validateShop = () => {
    if (
      allMyShop.data?.length === 1 &&
      allMyShop?.data[0]?.shop.applyLogicLockShop
    ) {
      message.error('ไม่สามารถเพิ่มร้านค้าได้');
      return false;
    }
    return true;
  };

  const addShops = async (values: any) => {
    const data = {
      buyer: currentUser._id,
      shop: values,
    };

    const validateResult = await validateShop();
    if (!validateResult) {
      return;
    }

    await axios.post(`${BASE_URL}/shop-buyer`, data);
    navigate('/my-shops');
  };

  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  useEffect(() => {
    if (currentUser._id) {
      getMyShop(currentUser._id);
    }
  }, [currentUser]);

  useEffect(() => {
    if (allShops.data) {
      setState({
        ...state,
        myShops: allShops.data,
      });
    }
  }, [allShops]);

  useEffect(() => {
    // if (allMyShop?.data?.length) {
    //   getAllShop();
    // } else {
    //   getAllShop();
    // }
  }, [allMyShop]);

  return (
    <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
      <Form form={form} onFinish={onFinish}>
        <div className={styles.container}>
          <div className={styles.addshop}>
            กรอกรหัสร้านค้าของท่าน <br />
            <Form.Item name='searchShop'>
              <Input width='50' />
            </Form.Item>
            <Form.Item>
              <Button type='primary' htmlType='submit'>
                ตรวจสอบร้านค้า
              </Button>
              &nbsp;
              <Button type='primary' onClick={getAllShop}>
                รีเซ็ต
              </Button>
            </Form.Item>
          </div>
        </div>
        <Form.Item>
          <div className={styles.normal_shop}>
            <div className={styles.border_buttom}>รายชื่อร้านค้า</div>
            <div style={{ marginTop: '20px' }}>
              {state.myShops?.map((item: any, index: number) => (
                <Row key={index}>
                  <Col span={10}>{item.name}</Col>
                  <Col span={6} offset={8}>
                    <Form.Item>
                      {item.isMyShop !== true && (
                        <>
                          <Button
                            type='primary'
                            htmlType='button'
                            onClick={() => addShops(item._id)}
                          >
                            เพิ่มร้านค้า
                          </Button>
                        </>
                      )}
                      {item.isMyShop === true && (
                        <>
                          <Button
                            disabled
                            type='primary'
                            htmlType='button'
                            onClick={() => addShops(item._id)}
                          >
                            เพิ่มร้านค้า
                          </Button>
                        </>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              ))}
            </div>
          </div>
        </Form.Item>
      </Form>
    </Layout>
  );
};
export default AddShopCreate;
